import { render, staticRenderFns } from "./About_ZZ.vue?vue&type=template&id=6c70a49d&scoped=true&"
import script from "./About_ZZ.vue?vue&type=script&lang=js&"
export * from "./About_ZZ.vue?vue&type=script&lang=js&"
import style0 from "./About_ZZ.vue?vue&type=style&index=0&id=6c70a49d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c70a49d",
  null
  
)

export default component.exports